import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getMe } from "../api/auth.api";
import { useAuthStore } from "../store/authStore";
import { ApiError } from "../api/client";

export function useAuth() {
  const initAuth = useAuthStore((s) => s.initAuth);

  const query = useQuery({
    queryKey: ["auth", "me"],
    queryFn: getMe,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (query.isLoading) return;
    initAuth(query.data ?? null);
  }, [query.data, query.isLoading, initAuth]);

  // Backend is unreachable if the error is NOT an ApiError (i.e. network/fetch failure)
  const isBackendDown = !!query.error && !(query.error instanceof ApiError);

  return { ...query, isBackendDown };
}
